import { Routes, Route, Navigate } from 'react-router-dom';

import { AppShell } from './app/AppShell';
import { StudioShell } from './studio/StudioShell';
import { LoginPage } from './app/auth/LoginPage';
import { NotFound } from './components/NotFound';

/**
 * Top-level router.
 *
 * Phase 0 baseline: shells render placeholder pages.
 * Phase 5+ replaces stubs with Chat, Map, Studio modules behind ProtectedRoute.
 */
export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/app" replace />} />
      <Route path="/login" element={<LoginPage />} />

      <Route path="/app/*" element={<AppShell />} />
      <Route path="/studio/*" element={<StudioShell />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
